<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tEQNZs/tc-custom/9781453290378.jpg?1700850014067" alt="This image is the cover for the book Manx Murders, The Niccolo Benedetti Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Manx Murders, The Niccolo Benedetti Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Niccolo Benedetti takes on the mysterious case of two battling industrialist twins</b><br/>In Harville, Pennsylvania, two brothers are sparring. A common enough occurrence, but these ones happen to be elderly, twins, and industrialist millionaires. The two have feuded for years over all sorts of issues, including a woman they both loved. Now Henry Pembroke has built a bird sanctuary, while his twin brother, Clyde, has decided to breed Manx cats. Henry argues that Clyde’s cats will kill his birds, and in an attempt for revenge, he blocks a new air-cleaning device that Clyde wants to produce.  After nearly a lifetime of fighting, the brothers call on renowned Italian detective—and larger-than-life artist-philosopher—Niccolo Benedetti, together with private investigator partner Ron Gentry, to help solve their differences. But what begins as a property dispute takes a lethal turn when one of the brothers is kidnapped and a secretary is murdered. In this quiet town, Benedetti, a lifelong student of evil, suddenly has more than enough to study. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William L. DeAndrea
      </h2>
      
      <p class="authorDescription body article">William L. DeAndrea (1952&ndash;1996) was born in Port Chester, New York. While working at the Murder Ink bookstore in New York City, he met mystery writer Jane Haddam, who became his wife. His first book, <i>Killed in the Ratings</i> (1978), won an Edgar Award in the best first mystery novel category. That debut launched a series centered on Matt Cobb, an executive problem-solver for a TV network who unravels murders alongside corporate foul play. DeAndrea&rsquo;s other series included the Nero Wolfe&ndash;inspired Niccolo Benedetti novels, the Clifford Driscoll espionage series, and the Lobo Blacke/Quinn Booker Old West mysteries. A devoted student of the mystery genre, he also wrote a popular column for the<i> Armchair Detective</i> newsletter. One of his last works, the Edgar Award&ndash;winning <i>Encyclopedia Mysteriosa</i> (1994), is a thorough reference guide to sleuthing in books, film, radio, and TV.&#160; &#160; &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07c63f9f